import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import 'reset.css'
import '@/assets/fontSize/iconfont.css'
createApp(App).use(router).mount('#app')
